import Alpine from 'alpinejs';

import 'op-flex/op-flex.css';

import './component/desktop';

window.Alpine = Alpine;
Alpine.start();
